import request from '@/utils/request'

/**
 * @description: 获取有所属学校的省份及数量
 * @param {*} params
 * @return {*}
 */
const schoolProvinces = () => {
  return request({
    url: '/admin/school/provinces',
    method: 'get'
  })
}

/**
 * @description: 分页查询学校列表
 * @param {*} params
 * @return {*}
 */
const schoolSearchByPage = (params) => {
  return request({
    url: '/admin/school/searchByPage',
    method: 'post',
    data: params
  })
}

/**
 * @description: 添加学校
 * @param {*} params
 * @return {*}
 */
const schoolCreate = (params) => {
  return request({
    url: '/admin/school/create',
    method: 'post',
    data: params
  })
}

/**
 * @description: 修改学校禁启用状态
 * @param {*} params
 * @return {*}
 */
const schoolUpdateStatus = (params) => {
  return request({
    url: '/admin/school/updateStatus',
    method: 'post',
    data: params
  })
}

/**
 * @description: 导出excel
 * @param {*} params
 * @return {*}
 */
const schoolExport = (params) => {
  return request({
    url: '/admin/school/export',
    method: 'post',
    data: params,
    responseType: 'blob'
  })
}

/**
 * @description: 批量查询省份对应的学校
 * @param {*} params
 * @return {*}
 */
const schoolBatchSchoolByProvinceId = (params) => {
  return request({
    url: '/admin/school/batchSchoolByProvinceId',
    method: 'get',
    params
  })
}

/**
 * @description: 修改学校禁启用状态
 * @return {*}
 */
const areaTree = () => {
  return request({
    url: '/admin/area/tree',
    method: 'get'
  })
}

export default {
  schoolProvinces,
  schoolSearchByPage,
  schoolCreate,
  schoolUpdateStatus,
  schoolExport,
  schoolBatchSchoolByProvinceId,
  areaTree
}
